import type { DeepPartial } from '@luna/utils-ts';

import { documentsROFeatureConfig } from './documents/RO';
import { miscROFeatureConfig } from './misc/RO';
import { ordersROFeatureConfig } from './orders/RO';
import { overviewROFeatureConfig } from './overview/RO';
import { pipROFeatureConfig } from './pip/RO';
import { printROFeatureConfig } from './print/RO';
import { productSettingsROFeatureConfig } from './productSettings/RO';
import { regularOrdersROFeatureConfig } from './regularOrders/RO';
import { searchROFeatureConfig } from './search/RO';
import { statementsROFeatureConfig } from './statements/RO';
import { titleDetailROConfig } from './titleDetail/RO';
import { tradingConfigRO } from './trading/RO';
import type { InvestmentsFeatureConfig } from '../types/InvestmentsFeatureConfig';

export const investments: DeepPartial<InvestmentsFeatureConfig> = {
    documents: documentsROFeatureConfig,
    misc: miscROFeatureConfig,
    orders: ordersROFeatureConfig,
    overview: overviewROFeatureConfig,
    pip: pipROFeatureConfig,
    print: printROFeatureConfig,
    productSettings: productSettingsROFeatureConfig,
    regularOrders: regularOrdersROFeatureConfig,
    search: searchROFeatureConfig,
    statements: statementsROFeatureConfig,
    titleDetail: titleDetailROConfig,
    trading: tradingConfigRO,
};
